import { SuiClient } from '@mysten/sui.js/client';
export async function executeSuiTransaction(params) {
    const { transactionBlock, signatures } = params;
    const suiClient = new SuiClient({
        url: 'https://sui-mainnet.blockvision.org/v1/2o4sVybXFInyr84XlR4U9aLpzP1',
    });
    try {
        const response = await suiClient.executeTransactionBlock({
            transactionBlock: transactionBlock,
            signature: signatures,
        });
        return {
            txHash: response.digest,
            explorerUrl: `https://explorer.sui.io/transaction/${response.digest}`,
            status: 'success',
        };
    }
    catch (error) {
        return {
            txHash: '',
            status: 'error',
            error: error.message,
        };
    }
}
